import React, { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import * as S from "./styles";
import { IProps } from "./types";
import { meForReview, meForReviewVariables } from "./__generated__/meForReview";
import { ME_FOR_REVIEW } from "./queries";
import { Loading, BreadCrumb } from "@atoms";
import { Table, Container } from "react-bootstrap";
import StarRatingComponent from "react-star-rating-component";
import { OffsetPagination, ReviewDetailModal } from "@molecules";
import { accountUrl } from "@src/app/routes";
import { useAlert } from "react-alert";

const MyReviewPage: React.FC<IProps> = ({}: IProps) => {
  const reviewsToShow = 12;
  const [variables, setVariables] = useState<meForReviewVariables>({first: reviewsToShow});
  const alert = useAlert();
  const {data, error, loading} = useQuery<meForReview>(ME_FOR_REVIEW, {
    variables,
    fetchPolicy: "no-cache",
  });

  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState('');
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [imgSrcs, setImgSrcs] = useState([]);

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = (title: string, rating: number, comment:string, imgSrcs:string[]) => {
    setTitle(title);
    setRating(rating);
    setComment(comment);
    setImgSrcs(imgSrcs);
    setShowModal(true);
  }
  const breadCrumbData = [
    {
      name: "My Account",
      link: accountUrl
    },
    {
      name: "My Reviews"
    }
  ]

  return data && (
    <S.Wrapper>
      <ReviewDetailModal
        show={showModal}
        onHide={handleModalClose}
        title={title}
        rating={rating}
        comment={comment}
        imgSrcs={imgSrcs}
      />
      <Container>
        <BreadCrumb
          data={breadCrumbData}
        />
        <S.HeaderWrapper>
          <S.Header>
            My reviews
          </S.Header>
        </S.HeaderWrapper>
        <Table responsive className="text-nowrap">
          {
            data.me.reviews.edges.length > 0 ?
            <>
            <thead>
              <tr>
                <td>Product</td>
                <td>Brand</td>
                <td>Title</td>
                <td style={{whiteSpace: "nowrap"}}>Review Rating</td>
                <td>Status</td>
              </tr>
            </thead>
            <tbody>
            {
              data?.me?.reviews?.edges?.map((edge, i) => {
                const review = edge.node;
                return (
                  <tr
                    key={i}
                    onClick={(e: any) => {
                      handleModalShow(
                        review.title,
                        review.rating,
                        review.comment,
                        review.images.map((img) => img.url))
                    }}
                  >
                    <td style={{whiteSpace: "nowrap"}}>{review.product.name}</td>
                    <td>{review.product.brand}</td>
                    <td>{review.title}</td>
                    <td>
                      <StarRatingComponent
                        name="ReviewRating"
                        editing={false}
                        starCount={5}
                        starColor="#F39"
                        emptyStarColor="#BFBFBF"
                        value={review.rating}
                      />
                    </td>
                    <td>{review.status}</td>
                  </tr>
                );
              })
            }
          </tbody>
          </>
          :
          (<S.NoDataCol>
            <S.NoData>THERE ARE NOT ANY REVIEW YET.</S.NoData>
          </S.NoDataCol>)
          }
        </Table>
        <OffsetPagination
          itemsToShow={reviewsToShow}
          startCursor={data.me.reviews.pageInfo.startCursor}
          totalCount={data.me.reviews.totalCount}
          setVariables={setVariables}
        />
      </Container>
    </S.Wrapper>
  ) || <Loading/>;
};

export { MyReviewPage }